import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { MEMBER_MODULE } from "@config";
import { selectUserInfo } from "@store/globalSlice";
import { MemberShip } from "@store/memberCenterSlice";

const regions = ["TH", "VN"];

export const useCategoryMemberModule = () => {
  let categoryMemberModual;

  if (location.pathname === "/creator" || location.pathname === "/product" || location.pathname === "/shop") {
    categoryMemberModual = MEMBER_MODULE.LIST_CATE_CASCADER_LIST;
  }

  return categoryMemberModual;
};

export const getListCategoryResult = (region: string, module: any, membership: any) => {
  if (module === "LIST.CATE_CASCADER_LIST") {
    if (location.pathname === "/product") {
      if (membership?.expired === true || membership?.level === "Trial") {
        return {
          showMask: true,
          action: "Upgrade",
          desc: "Upgrade to view more data",
          expired: membership?.expired,
          level: membership?.level,
        };
      }
    } else {
      if (membership?.expired === true || membership?.level === "Trial") {
        return {
          showMask: true,
          action: "Upgrade",
          desc: "CategoryMembershipUpgrageDesc",
          expired: membership?.expired,
          level: membership?.level,
        };
      }

      if (regions.includes(region)) {
        if (
          membership?.level === "Basic" &&
          membership?.start &&
          dayjs(membership?.start).isAfter(dayjs("2023-06-09"))
        ) {
          return {
            showMask: true,
            action: "Upgrade",
            desc: "CategoryMembershipUpgrageDesc",
            expired: membership?.expired,
            level: membership?.level,
          };
        }
      } else {
        if (
          membership?.level === "Basic" &&
          membership?.start &&
          dayjs(membership?.start).isAfter(dayjs("2023-07-14"))
        ) {
          return {
            showMask: true,
            action: "Upgrade",
            desc: "CategoryMembershipUpgrageDesc",
            expired: membership?.expired,
            level: membership?.level,
          };
        }
      }
    }
  }
  return null;
};

// 隐藏基础套餐
export const useHideMemberBasic = () => {
  const userInfo = useSelector(selectUserInfo);
  if (userInfo.bizCountry === "china" || userInfo.bizCountry === "vietnam") {
    return true;
  } else {
    return false;
  }
};

export const modifyCompareFeatureList = (feature: any) => {
  const newFeature = { ...feature };

  if (feature.key === "SHOP.LIST") {
    newFeature.trial = 10;
    newFeature.basic = 10;
  }
  if (newFeature.key === "PRODUCT.LIST") {
    newFeature.trial = 10;
  }
  if (newFeature.key === "CREATOR.LIST") {
    newFeature.basic = 10;
  }
  if (newFeature.key === "OVERVIEW.POTENTIAL_LIST") {
    newFeature.trial = 1;
    newFeature.basic = 10;
  }
  if (newFeature.key === "OVERVIEW.DETAIL") {
    newFeature.trial = 0;
    newFeature.basic = 1;
  }
  if (newFeature.key === "VIDEO.LIST") {
    newFeature.trial = 10;
  }
  return newFeature;
};

export const modifyMemberDynamicConfig = (region: string, dynamicConfig: any, membership: MemberShip) => {
  const newDynamicConfig = { ...dynamicConfig };
  if (membership?.expired === false) {
    if (membership.level === "Trial") {
      newDynamicConfig["SHOP.LIST"] = { ...newDynamicConfig["SHOP.LIST"], count: 10 };
      newDynamicConfig["PRODUCT.LIST"] = { ...newDynamicConfig["PRODUCT.LIST"], count: 10 };
      newDynamicConfig["OVERVIEW.POTENTIAL_LIST"] = { ...newDynamicConfig["OVERVIEW.POTENTIAL_LIST"], count: 1 };
      newDynamicConfig["OVERVIEW.DETAIL"] = { ...newDynamicConfig["OVERVIEW.DETAIL"], count: 0 };
      newDynamicConfig["VIDEO.LIST"] = { ...newDynamicConfig["VIDEO.LIST"], count: 10 };
    }
    if (membership.level === "Basic") {
      if (regions.includes(region)) {
        if (membership?.start && dayjs(membership?.start).isAfter(dayjs("2023-06-09"))) {
          newDynamicConfig["SHOP.LIST"] = { ...newDynamicConfig["SHOP.LIST"], count: 10 };
          newDynamicConfig["CREATOR.LIST"] = { ...newDynamicConfig["CREATOR.LIST"], count: 10 };
        }
        if (membership?.start && dayjs(membership?.start).isAfter(dayjs("2023-06-27"))) {
          newDynamicConfig["OVERVIEW.POTENTIAL_LIST"] = { ...newDynamicConfig["OVERVIEW.POTENTIAL_LIST"], count: 10 };
          newDynamicConfig["OVERVIEW.DETAIL"] = { ...newDynamicConfig["OVERVIEW.DETAIL"], count: 1 };
        }
      } else {
        if (membership?.start && dayjs(membership?.start).isAfter(dayjs("2023-07-14"))) {
          newDynamicConfig["SHOP.LIST"] = { ...newDynamicConfig["SHOP.LIST"], count: 10 };
          newDynamicConfig["CREATOR.LIST"] = { ...newDynamicConfig["CREATOR.LIST"], count: 10 };
          newDynamicConfig["OVERVIEW.POTENTIAL_LIST"] = { ...newDynamicConfig["OVERVIEW.POTENTIAL_LIST"], count: 10 };
          newDynamicConfig["OVERVIEW.DETAIL"] = { ...newDynamicConfig["OVERVIEW.DETAIL"], count: 1 };
        }
      }
    }
  }
  return newDynamicConfig;
};

export const addCompareFeatureCategory = (feature: any, moduleFeatures: any) => {
  if (feature.key === "SHOP.LIST") {
    moduleFeatures[feature.module].push({
      type: "MODULE",
      name: "Shop Category",
      trial: "L1",
      basic: "L1",
      standard: "Unlimited",
      premium: "Unlimited",
    });
  }
  if (feature.key === "PRODUCT.LIST") {
    moduleFeatures[feature.module].push({
      type: "MODULE",
      name: "Product Category",
      trial: 0,
      basic: 1,
      standard: 1,
      premium: 1,
    });
  }
  if (feature.key === "CREATOR.LIST") {
    moduleFeatures[feature.module].push({
      type: "MODULE",
      name: "Creator Category",
      trial: 0,
      basic: 0,
      standard: 1,
      premium: 1,
    });
  }
};
